import React from 'react';

const colorMap = {
  GOOD: 'bg-emerald-500/15 text-emerald-200 border-emerald-500/40',
  WATCH: 'bg-amber-500/15 text-amber-200 border-amber-500/40',
  DEGRADED: 'bg-orange-500/15 text-orange-200 border-orange-500/40',
  CRITICAL: 'bg-rose-500/15 text-rose-200 border-rose-500/40',
  LOW: 'bg-emerald-500/15 text-emerald-200 border-emerald-500/40',
  MEDIUM: 'bg-amber-500/15 text-amber-200 border-amber-500/40',
  HIGH: 'bg-orange-500/15 text-orange-200 border-orange-500/40',
};

const ExperienceRiskBadge = ({ level }) => {
  const key = String(level || '').toUpperCase();
  const cls = colorMap[key] || 'bg-slate-700/50 text-slate-200 border-slate-600';
  return (
    <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-medium ${cls}`}>
      {key || '-'}
    </span>
  );
};

export default ExperienceRiskBadge;
